<div class="work-inspection-container">
  <div *ngIf="!verificationSolution" class="missing-inspection-banner">
    <mat-icon>warning</mat-icon>
    <span>{{ 'work_inspection_inspection_solution_missing' | translate }}</span>
  </div>

  <mat-tab-group class="solution-tabs" [selectedIndex]="selectedSolutionIndex" (selectedTabChange)="onSolutionTabChange($event)" animationDuration="0ms">
    <mat-tab *ngIf="originalSolution" [label]="originalSolution.displayName || ('work_inspection_solutions_reference' | translate)"></mat-tab>
    <mat-tab *ngIf="verificationSolution" [label]="verificationSolution.displayName || ('work_inspection_solutions_follow_up' | translate)"></mat-tab>
  </mat-tab-group>

  <div class="inspection-header-info">
    <div class="indicator-selector">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'synthese_col_indicator' | translate }}</mat-label>
        <mat-select [(value)]="selectedIndicatorIndex" (selectionChange)="recalculateSolutionTotal()">
          <mat-option *ngFor="let indicator of allIndicators; let i = index" [value]="i"> {{ indicator.displayName | localizedLabel: 'indicator' : indicator.code }} ({{ indicator.workUnityDisplayShortName }}) </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="total-display" *ngIf="activeIndicator">
      {{ 'project_total' | translate }} {{ activeIndicator.displayName | localizedLabel: 'indicator' : activeIndicator.code }} =
      <strong>{{ getTotalSolutionValue() }} {{ activeIndicator.workUnityDisplayShortName }}</strong>
    </div>
    <div class="to-adjust-display" *ngIf="operationsToAdjustCount > 0" [matTooltip]="'work_inspection_solutions_to_adjust_hint' | translate">
      <mat-icon>error_outline</mat-icon>
      <span>{{ 'work_inspection_solutions_to_adjust' | translate: { count: operationsToAdjustCount } }}</span>
    </div>
  </div>

  <div *ngIf="isEditable && verificationSolution" class="periodicity-toggle-container">
    <mat-slide-toggle [(ngModel)]="verificationSolution.isTemporalityEnabled" (change)="onPeriodicityToggleChange()" labelPosition="before"> {{ 'work_inspection_solutions_period_tracking' | translate }} </mat-slide-toggle>
    <button *ngIf="verificationSolution.isTemporalityEnabled" mat-mini-fab color="accent" class="add-period-button-floating" [matTooltip]="'work_inspection_solutions_add_period' | translate" (click)="addNewPeriod()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="!isEditable || !verificationSolution || !verificationSolution.isTemporalityEnabled">
    <h3 class="title-margin-top">{{ 'project_section_operations' | translate }}</h3>

    <div *ngIf="isConsolidatedView" class="consolidated-banner">
      <mat-icon>info_outline</mat-icon>
      <span>{{ 'work_inspection_solutions_consolidated_notice' | translate: { count: consolidatedPeriodCount } }}</span>
      <span *ngIf="operationsToAdjustCount > 0" class="banner-to-adjust">{{ 'work_inspection_solutions_to_adjust' | translate: { count: operationsToAdjustCount } }}</span>
    </div>

    <mat-accordion multi class="operations-accordion">
      <app-solution-operation
        *ngFor="let operation of getDisplayedOperations(); trackBy: trackByOperationId"
        [operation]="operation"
        [isEditable]="isOperationEditable(operation)"
        [activeIndicator]="activeIndicator!"
        [allIndicators]="allIndicators"
        [wsAppPath]="wsAppPath"
        [versionId]="versionId"
        (operationDeleteRequested)="onOperationDeleteRequested($event)"
        (operationUpdated)="onOperationUpdated($event)">
      </app-solution-operation>
    </mat-accordion>
  </ng-container>

  <ng-container *ngIf="isEditable && verificationSolution && verificationSolution.isTemporalityEnabled">
    <div class="periodicity-view">
      <div class="period-tabs-header">
        <mat-tab-group class="period-tabs" #periodTabs animationDuration="0ms">
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="period-tab-label drop-zone" (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onPeriodDrop($event, undefined)">
                <span>{{ 'work_inspection_solutions_unassigned_operations' | translate }}</span>
              </div>
            </ng-template>
            <div class="period-content">
              <ng-container *ngIf="getOperationsForPeriod().length > 0; else noUnassignedOps">
                <h3 class="title-margin-top">{{ 'project_section_operations' | translate }}</h3>
                <app-solution-operation
                  *ngFor="let operation of getOperationsForPeriod(); trackBy: trackByOperationId"
                  [operation]="operation"
                  [isEditable]="isEditable"
                  [activeIndicator]="activeIndicator!"
                  [allIndicators]="allIndicators"
                  [wsAppPath]="wsAppPath"
                  [isPeriodModeEnabled]="true"
                  [allPeriods]="verificationSolution.solutionTemporalities || []"
                  [versionId]="versionId"
                  [periodAssignments]="getPeriodAssignments(operation)"
                  [copyRootName]="getCopyRootName(operation)"
                  (periodsChanged)="onPeriodsChanged($event)"
                  (operationDeleteRequested)="onOperationDeleteRequested($event)"
                  (operationUpdated)="onOperationUpdated($event)">
                </app-solution-operation>
              </ng-container>
              <ng-template #noUnassignedOps>
                <div class="empty-period-message">{{ 'work_inspection_solutions_no_unassigned' | translate }}</div>
              </ng-template>
            </div>
          </mat-tab>

          <!-- Dynamic Tabs for each Period -->
          <mat-tab *ngFor="let period of verificationSolution.solutionTemporalities">
            <div class="period-tab-label-container">
              <ng-template mat-tab-label>
                <div class="period-tab-label drop-zone" (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onPeriodDrop($event, period.temporalityId)">
                  <span class="period-tab-name">
                    {{ period.name }}
                    <span class="period-to-adjust-dot" *ngIf="periodNeedsAdjustment(period.temporalityId)" [matTooltip]="'work_inspection_solutions_period_to_adjust' | translate"></span>
                  </span>
                  <div class="period-actions">
                    <button mat-icon-button (click)="editPeriod(period, $event)" [matTooltip]="'work_inspection_solutions_edit_name' | translate">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button (click)="duplicatePeriod(period, $event)" [matTooltip]="'work_inspection_solutions_duplicate_period' | translate">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <button mat-icon-button (click)="deletePeriod(period, $event)" [matTooltip]="'work_inspection_solutions_delete_period' | translate">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
            <div class="period-content">
              <ng-container *ngIf="getOperationsForPeriod(period.temporalityId).length > 0; else noPeriodOps">
                <app-solution-operation
                  *ngFor="let operation of getOperationsForPeriod(period.temporalityId); trackBy: trackByOperationId"
                  [operation]="operation"
                  [isEditable]="isEditable"
                  [activeIndicator]="activeIndicator!"
                  [allIndicators]="allIndicators"
                  [wsAppPath]="wsAppPath"
                  [isPeriodModeEnabled]="true"
                  [allPeriods]="verificationSolution.solutionTemporalities || []"
                  [versionId]="versionId"
                  [periodAssignments]="getPeriodAssignments(operation)"
                  [copyRootName]="getCopyRootName(operation)"
                  (periodsChanged)="onPeriodsChanged($event)"
                  (operationDeleteRequested)="onOperationDeleteRequested($event)"
                  (operationUpdated)="onOperationUpdated($event)">
                </app-solution-operation>
              </ng-container>
              <ng-template #noPeriodOps>
                <div class="empty-period-message">{{ 'work_inspection_solutions_no_operations_in_period' | translate }}</div>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </ng-container>
</div>
